import styles from "./addcomplaint.module.css";
import { Select, FormControl, InputLabel, MenuItem, ListSubheader, TextField, Button, Autocomplete, createFilterOptions } from "@mui/material";
import { Plus, X, UploadCloud } from "react-feather";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import axios from 'axios';
import { useState } from "react";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from 'react-smart-toaster';
import { AddLogCallAPI } from "../../../components/AddLogs";

const schema = yup.object().shape({
    tenant_id: yup.string().required('This field is Required'),
    category: yup.string().required('This field is Required'),
    description: yup.string().required('This field is Required').max(200, 'Description cannot be more than 200 characters'),
    priority: yup.string().required('This field is Required')
});

const filterOptions = createFilterOptions({
    matchFrom: 'start'
});

const categoryGroupOptions = [
    { label: "Categories", parent: 1 },
    { value: "Garbage Removal", label: "Garbage Removal", parent: 0, category: "Categories", img_path: "/static/img/garbage.svg" },
    { value: "Noise", label: "Noise", parent: 0, category: "Categories", img_path: "/static/img/noise.svg" },
    { label: "Other", parent: 1 },
    { value: "Other Issue", label: "Other Issue", parent: 0, category: "Other", img_path: "/static/img/other.svg" },
];

const AddComplaint = ({ setAddModalOpen, tenant_id, setLoading, setSnackbarOpen, setSnackbarMsg, onSubmitLocal, complaintData }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [tenantList, setTenantList] = useState([]);
    const [charsLeft, setCharsLeft] = useState(200);
    const [imgPathTemp, setImgPathTemp] = useState({ files: [], paths: [] });
    const [prevImages, setPrevImages] = useState([]);

    const { handleSubmit, control, errors, setValue, clearErrors } = useForm({
        resolver: yupResolver(schema),
        mode: 'onChange',
        defaultValues: {
            tenant_id: "",
            category: "",
            description: "",
            priority: ""
        }
    });

    useEffect(() => {
        if (complaintData) {
            setValue('tenant_id', parseInt(complaintData?.tenant_id));
            setValue('category', complaintData?.category);
            setValue('description', complaintData?.description);
            setValue('priority', complaintData?.priority);
            setPrevImages(complaintData?.images);
        }
    }, [complaintData, tenantList, setValue]);

    useEffect(() => {
        async function fetchTenants() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_CASE_API_URL + "v1/property-tenant-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                let tFinalList2 = [];

                let templistNew = response.data.data;
                if (tenant_id) {
                    templistNew = response.data.data?.map(item => {
                        let opts = item?.options?.filter(i => i?.value === parseInt(tenant_id));
                        return { ...item, options: opts };
                    });
                    templistNew = templistNew.filter(i => i.options?.length > 0);

                    setValue('tenant_id', parseInt(tenant_id));
                }

                templistNew?.map((item) => {
                    item?.options?.map((subItem) => {
                        tFinalList2.push({
                            group: item?.label,
                            value: subItem?.value,
                            label: subItem.label
                        });
                        return false;
                    });

                    return false;
                });

                setTenantList(tFinalList2);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        }

        fetchTenants();
    }, [getAccessTokenSilently, tenant_id]);

    const fileHandler = (e) => {
        var validExtensions = ["jpg", "jpeg", "png", "svg"];
        var fileName = e.target.files[0].name;
        var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
        if (validExtensions.indexOf(fileNameExt.toLowerCase()) === -1) {
            toast.error("File type is not allowed");
        } else if (e.target.files[0].size > 5242880) {
            toast.error("Image size should not be greater than 5 mb.");
        } else {
            for (let n = 0; n < e.target.files.length; n++) {
                let file = e.target.files[n];

                setImgPathTemp(prev => {
                    return { files: prev?.files?.concat(file), paths: prev?.paths?.concat(URL.createObjectURL(file)) };
                })
            }
        }
    }

    const onSubmit = async (data) => {
        let formData = new FormData();
        Object.keys(data).map((key) => {
            formData.append(key, data[key]);
            return true;
        });
        if (imgPathTemp.files.length) {
            for (let n in imgPathTemp.files) {
                formData.append("uploadImages[]", imgPathTemp.files[n]);
            }
        }

        setAddModalOpen(false);
        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_CASE_API_URL + "v1/complaints", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            onSubmitLocal(response.data.data);

            let logData = {
                title: "A new complaint has been created.",
                description: [
                    "Name: " + response.data.data.title,
                    "Complaint number: " + response.data.data.complaint_no,
                    "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onUpdate = async (data) => {
        if (prevImages?.length > 0) {
            let pImagesId = prevImages?.map(i => {
                return i?.id;
            });
            data = { ...data, prev_images: pImagesId.join(",") };
        } else {
            data = { ...data, prev_images: "" };
        }

        let formData = new FormData();
        Object.keys(data).map((key) => {
            formData.append(key, data[key]);
            return true;
        });
        if (imgPathTemp.files.length) {
            for (let n in imgPathTemp.files) {
                formData.append("uploadImages[]", imgPathTemp.files[n]);
            }
        }

        setAddModalOpen(false);
        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_CASE_API_URL + "v1/complaints/" + complaintData?.id, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            setLoading(false);

            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            onSubmitLocal(response.data.data);

            let logData = {
                title: "A complaint has been updated.",
                description: [
                    "Name: " + response.data.data.title,
                    "Complaint number: " + response.data.data.complaint_no,
                    "Apt No: " + response.data.data.property_name + " - " + response.data.data.apt_name,
                    "Tenant: " + response.data.data.tenant_name,
                ],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const onError = (error) => {
        console.log('error');
        console.log(error);
    }

    return (<div className={`${styles.ModalFormGroup}`}>
        <form onSubmit={handleSubmit(complaintData ? onUpdate : onSubmit, onError)}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className={`${styles.ReqAddRow}`}>
                    <div className={`${styles.ReqAddFormSec}`}>
                        <div className={`${styles.FormSec}`}>
                            <div className={`${styles.FormGroupFull} FormGroup`}>
                                <label className={`${styles.FilterLabel}`}>Tenant Selection</label>
                                <FormControl fullWidth>
                                    <Controller
                                        name="tenant_id"
                                        control={control}
                                        render={(field) => (<Autocomplete
                                            value={field?.value ? tenantList?.filter(i => i?.value === field?.value)[0] : null}
                                            filterOptions={filterOptions}
                                            options={tenantList.sort((a, b) => -b.group.localeCompare(a.group))}
                                            groupBy={(option) => option.group}
                                            getOptionLabel={(option) => option.label}
                                            renderInput={(params) => (<TextField {...params} label="Select Tenant*" />)}
                                            onChange={(event, newValue) => {
                                                setValue('tenant_id', newValue?.value);
                                                clearErrors();
                                            }}
                                        />)}
                                    />
                                </FormControl>
                                {errors.tenant_id && (<p className={`${styles.ErrorM}`}>{errors.tenant_id.message}</p>)}
                            </div>
                        </div>
                        <div className={`${styles.FormSec}`}>
                            <div className={`${styles.FormGroupFull} FormGroup`} >
                                <label className={`${styles.FilterLabel}`}>Category Selection</label>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select Category*</InputLabel>
                                    <Controller
                                        name="category"
                                        control={control}
                                        render={(field) => (
                                            <Select
                                                label="Select Category*"
                                                {...field}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                }}
                                            >
                                                {categoryGroupOptions.map((item) => {
                                                    if (item?.parent === 1)
                                                        return (<ListSubheader className={`${styles.GropSelectTitle}`}>{item?.label}</ListSubheader>);
                                                    else
                                                        return (<MenuItem value={item?.value} className={`${styles.GropSelectList}`}>
                                                            <img src={item?.img_path} alt="" />
                                                            {item?.label}
                                                        </MenuItem>);
                                                })}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors.category && (<p className={`${styles.ErrorM}`}>{errors.category.message}</p>)}
                            </div>
                        </div>
                        <div className={`${styles.FormSec}`}>
                            <div className={`${styles.FormGroupFull} FormGroup`}>
                                <label className={`${styles.FilterLabel}`}>Describe the Maintenance Issue</label>
                                <Controller
                                    name={`description`}
                                    control={control}
                                    render={(field) => (
                                        <TextField
                                            {...field}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setCharsLeft(200 - e.target.value.length);
                                            }}
                                            id="outlined-multiline-static"
                                            label="Add Description*"
                                            variant="outlined"
                                            inputProps={{ maxLength: 200 }}
                                            multiline
                                            rows={6}
                                        />
                                    )}
                                />
                                <p className={`${styles.RemainingText}`}>{charsLeft} {charsLeft > 1 ? "characters" : "character"} remaining</p>
                                {errors.description && (<p className={`${styles.ErrorM}`}>{errors?.description?.message}</p>)}
                            </div>
                        </div>
                        <div className={`${styles.FormSec}`}>
                            <div className={`${styles.FormGroupFull} FormGroup`}>
                                <label className={`${styles.FilterLabel}`}>Priority Level</label>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select Priority*</InputLabel>
                                    <Controller
                                        name="priority"
                                        control={control}
                                        render={(field) => (
                                            <Select
                                                label="Select Priority*"
                                                {...field}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                }}
                                            >
                                                <MenuItem value={1}>Low</MenuItem>
                                                <MenuItem value={2}>Medium</MenuItem>
                                                <MenuItem value={3}>High</MenuItem>
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                                {errors.priority && (<p className={`${styles.ErrorM}`}>{errors.priority.message}</p>)}
                            </div>
                        </div>
                        <div className={`${styles.FormIMGSec} ${styles.FileUploadSmall}`}>
                            <label className={`${styles.FilterLabel}`}>Share a photo</label>
                            <div className={`${styles.FileIMGDiv}`}>
                                {imgPathTemp.paths.length === 0 && <label className={`${styles.TakePhoteBU}`} for="file-upload"><UploadCloud /> Upload Photo</label>}
                                {imgPathTemp.paths.length === 0 && <p className={`${styles.UploadTextNew}`}>File size upto 5 MB. JPEG, JPG, PNG only</p>}
                                <input id="file-upload" type="file" onChange={fileHandler} accept=".jpg,.png,.jpeg,.svg" inputProps={{ accept: "image/*" }} style={{ display: 'none' }} />
                                <div className={`${styles.UpIMGSec}`}>
                                    {prevImages?.map((i1, i2) => {
                                        return <div className={`${styles.ImgFile}`}>
                                            <img src={i1?.file_public_url} alt="" />
                                            <Button onClick={(e) => {
                                                setPrevImages(prev => {
                                                    return prev?.filter((_, i) => i !== i2);
                                                })
                                            }}> <X /> </Button>
                                        </div>
                                    })}
                                    {imgPathTemp?.paths?.map((i1, i2) => {
                                        return <div className={`${styles.ImgFile}`}>
                                            <img src={i1} alt="" />
                                            <Button onClick={(e) => {
                                                setImgPathTemp(prev => {
                                                    return { files: prev?.files?.filter((_, i) => i !== i2), paths: prev?.paths?.filter((_, i) => i !== i2) };
                                                })
                                            }}> <X /> </Button>
                                        </div>
                                    })}
                                    {imgPathTemp.paths.length > 0 && <label className={`${styles.TakePhoteSQRBU}`} for="file-upload"><Plus /></label>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </LocalizationProvider>
            <div className={`${styles.ButtonAction}`}>
                <Button onClick={() => setAddModalOpen(false)} className="CancelPopupBU">Cancel</Button>
                <Button className="SubmitPopupBU" type="submit">{complaintData ? 'Update' : 'Add'}</Button>
            </div>
        </form>
    </div>);
};

export default AddComplaint;